

























































































































































































import IListStatusOutbound from '@/store/models/IListStatusOutbound';
import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
import Snackbar from '@/components/shared/Snackbar.vue';
import IRolePermission from '@/store/models/IRolePermission';

@Component({
    components: { Snackbar }
})
export default class ListStatusOutboundsSelector extends Vue {
  searchListStatusOutbounds = "";
  dialog = false;
  isValid = true;
  sortBy = 'name';
  sortDesc = false;

  headers: any = [
      { text: 'Name', value: 'name' },
      { text: 'Color', value: 'color' },
      { text: 'Actions', value: 'actions', sortable: false }
  ];

  editedIndex = -1;
  editedItem: IListStatusOutbound = { id: "", name: "", isFinished: false, color: "", idCompany: "" };
  defaultItem: IListStatusOutbound = { id: "", name: "", isFinished: false, color: "", idCompany: "" };

  @Prop({ type: Array, required: true }) ListStatusOutboundsList!: IListStatusOutbound[];
  @Prop({ type: Array, required: true }) Permissions!: IRolePermission[];

  selectedListStatusOutbounds: IListStatusOutbound[] = [];

  availableColors: string[] = [
      'red', 'green', 'blue', 'orange', 'purple', 'cyan', 'teal', 'pink', 'grey', 'brown'
  ];

  get formTitle() {
      return this.editedIndex === -1 ? 'New Outbound Status' : 'Edit Outbound Status';
  }

  @Watch('dialog')
  onDialogChanged(val: any) {
      val || this.close();
  }

  resetListStatusOutbounds() {
      this.selectedListStatusOutbounds = [];
  }

  editListStatusOutbound(item: any) {
      this.editedIndex = this.ListStatusOutboundsList.indexOf(item);
      this.editedItem = Object.assign({}, item);
      this.dialog = true;
  }

  saveListStatusOutbound() {
      if ((this.$refs.form as Vue & { validate: () => boolean }).validate()) {
          if (this.editedIndex > -1 || this.selectedListStatusOutbounds[0]) {
              this.close();
              this.$emit('editListStatusOutbound', this.editedItem);
              Object.assign(this.ListStatusOutboundsList[this.editedIndex], this.editedItem);
          } else {
              this.selectedListStatusOutbounds[0] = this.editedItem;
              this.$emit('saveListStatusOutbound', this.editedItem);
          }
          this.close();
      } else {
          this.$emit('showMessageWarning', 'All required fields must be filled out');
      }
  }

  deleteListStatusOutbound(statusOutbound: IListStatusOutbound) {
      this.$emit('deleteListStatusOutbound', statusOutbound);
      this.close();
  }

  close() {
      this.dialog = false;
      this.$nextTick(() => {
          this.editedItem = Object.assign({}, this.defaultItem);
          this.editedIndex = -1;
      });
  }

  selectListStatusOutbounds(item: any) {
      if (!this.selectedListStatusOutbounds.includes(item)) {
          this.selectedListStatusOutbounds = [item];
      } else {
          this.selectedListStatusOutbounds = [];
      }
  }

  showMessageInfo(message: string) {
      (this.$refs.snackbar as Snackbar).showInfo(message);
  }
  showMessageError(message: string) {
      (this.$refs.snackbar as Snackbar).showError(message);
  }
  showMessageWarning(message: string) {
      (this.$refs.snackbar as Snackbar).showWarning(message);
  }
}
